import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          关于97影院的常见疑问解答
        </p>
        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqData.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-lg p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}